import { FC } from 'react';
import { Link } from 'react-router-dom';
import { RouterConfig } from '@edikk-edikk/shared';
import footerLinkCss from '#srcCssModules/footer/footer-link.module.scss';
import { FooterLinkType } from '#base/types';

type PropsType = {
  footerLink: FooterLinkType;
};

const FooterLink: FC<PropsType> = ({
  footerLink,
}) => (
  <Link
    to={footerLink.slug}
    state={{ routerConfig: RouterConfig.initForPage(footerLink.id) }}
    className={footerLinkCss.footerLink}
  >
    {footerLink.title}
  </Link>
);

export { FooterLink };
